<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ติดต่อ Device</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!isShowFormCommands">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
        </div>
      </v-scroll-x-transition>
    </div>
    <!-- <v-toolbar flat color="blue-grey lighten-4">
      <span class="font-weight-medium">ติดต่อ Device</span>
      <v-scroll-x-transition>
        <v-row align="center" v-show="!isShowFormCommands">
          <v-spacer></v-spacer>
          <v-col md="3" lg="3" xl="2">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              clearable
              flat
              solo
              dense
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-scroll-x-transition>
    </v-toolbar> -->
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="hardwares"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="setDataRowSelected"
    >
      <template v-slot:item.hardware_status="{ item }">
        <span
          v-if="
            item.hardware_status &&
            item.hardware_status.title_th === 'อยู่ระหว่างซ่อม'
          "
          class="red--text"
        >
          {{ item.hardware_status.title_th }}
        </span>
        <span v-else>{{ item.hardware_status.title_th }}</span>
      </template>
    </v-data-table>
    <HardwareConnectionFormCommands
      :isShowForm="isShowFormCommands"
      :hardware="hardware"
      :commands="commands"
      @onClickCommand="handleFormCommandsClickCommand"
      @onClickClose="handleFormCommandsClickClose"
    />
    <HardwareConnectionFormIdentifyMode
      :isShowForm="isShowFormIdentifyMode"
      :commandData="commandDataFormIdentifyMode"
      @isHardwareConnectionFormIdentifyModeDataChange="
        handleHardwareConnectionFormIdentifyModeDataChange
      "
      @onClickBack="() => (isShowFormIdentifyMode = false)"
      @onClickNext="handleFormIdentifyModeClickNext"
    />
    <HardwareConnectionFormEmployeeList
      :isShowForm="isShowFormEmployeeList"
      :commandData="commandDataFormEmployeeList"
      @isHardwareConnectionFormEmployeeListDataChange="
        handleHardwareConnectionFormEmployeeListDataChange
      "
      @onClickBack="() => (isShowFormEmployeeList = false)"
      @onClickSendCommand="handleFormEmployeeListClickSendCommand"
    />
    <HardwareConnectionFormEmployeeSyncList
      :isShowForm="isShowFormEmployeeSyncList"
      :hardware="hardware"
      :commandData="commandDataFormEmployeeSyncList"
      @onClickBack="handleFormEmployeeSyncListClickBack"
      @onClickResponse="handleFormEmployeeSyncListClickResponse"
    />
    <HardwareConnectionFormCommandResponse
      :isShowForm="isShowFormResponse"
      :commandData="commandDataFormResponse"
      @onClickBack="() => (isShowFormResponse = false)"
    />
    <HardwareConnectionFormCommand
      :isShowForm="isShowFormCommand"
      :hardware="hardware"
      :commandData="commandDataFormCommand"
      @onClickBack="handleFormCommandClickBack"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay :value="isShowFormCommands" z-index="0"></v-overlay>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

import HardwareConnectionFormCommandResponse from '@/views/hardware/HardwareConnectionFormCommandResponse'
import HardwareConnectionFormEmployeeList from '@/views/hardware/HardwareConnectionFormEmployeeList'
import HardwareConnectionFormEmployeeSyncList from '@/views/hardware/HardwareConnectionFormEmployeeSyncList'
import HardwareConnectionFormIdentifyMode from '@/views/hardware/HardwareConnectionFormIdentifyMode'

import HardwareConnectionFormCommand from '@/views/hardware/HardwareConnectionFormCommand'
import HardwareConnectionFormCommands from '@/views/hardware/HardwareConnectionFormCommands'

export default {
  components: {
    ConfirmDialog,
    HardwareConnectionFormEmployeeList,
    HardwareConnectionFormEmployeeSyncList,
    HardwareConnectionFormCommandResponse,
    HardwareConnectionFormIdentifyMode,
    HardwareConnectionFormCommands,
    HardwareConnectionFormCommand,
  },

  data() {
    return {
      loading: true,
      search: '',
      sortBy: ['hardware_serial_number'],
      sortDesc: [false],
      headers: [
        { text: 'Serial Number', value: 'hardware_serial_number' },
        { text: 'รหัส Device', value: 'hardware_code' },
        { text: 'ชื่อ Device', value: 'title_th' },
        { text: 'ชื่อ Device (อังกฤษ)', value: 'title_en' },
        { text: 'ชื่อรุ่น Device', value: 'hardware_model.title' },
        { text: 'สถานะ Device', value: 'hardware_status' },
      ],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      hardware: {},
      isShowFormCommands: false,
      commands: [],
      commandComponentType: {
        get_device_info: 'HardwareGetDeviceInfo',
        get_employee_list: 'HardwareGetEmployeeList',
      },
      timeout: null,
      isShowFormCommand: false,
      commandDataFormCommand: {},
      isShowFormEmployeeList: false,
      commandDataFormEmployeeList: {},
      isShowFormEmployeeSyncList: false,
      commandDataFormEmployeeSyncList: {},
      isShowFormResponse: false,
      commandDataFormResponse: {},
      isShowFormIdentifyMode: false,
      commandDataFormIdentifyMode: {},
      isHardwareConnectionFormEmployeeListDataChange: false,
      isHardwareConnectionFormIdentifyModeDataChange: false,
    }
  },

  computed: {
    hardwares() {
      return this.$store.state.hardware.hardwares
    },
  },

  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ติดต่อ Device',
        disabled: true,
      },
    ])

    this.loadData()
  },

  methods: {
    ...mapActions({
      fetchHardwares: 'hardware/fetchHardwares',
      fetchCodes: 'hardware/fetchCodes',
      fetchOrganizationsWithQueryString:
        'hardware/fetchOrganizationsWithQueryString',
      fetchEmployeesWithQueryString: 'hardware/fetchEmployeesWithQueryString',
    }),

    handleHardwareConnectionFormEmployeeListDataChange(value) {
      this.isHardwareConnectionFormEmployeeListDataChange = value
    },

    handleHardwareConnectionFormIdentifyModeDataChange(value) {
      this.isHardwareConnectionFormIdentifyModeDataChange = value
    },

    handleFormIdentifyModeClickNext(payload) {
      this.commandDataFormEmployeeList = { ...payload }
      this.isShowFormEmployeeList = true
    },

    handleFormEmployeeSyncListClickBack() {
      this.isShowFormEmployeeSyncList = false
      this.isShowFormEmployeeList = false
      this.isShowFormIdentifyMode = false
      this.commandDataFormIdentifyMode = {}
      this.commandDataFormEmployeeList = {}
      this.commandDataFormEmployeeSyncList = {}
    },

    handleFormEmployeeSyncListClickResponse(payload) {
      this.commandDataFormResponse = { ...payload }
      this.isShowFormResponse = true
    },

    handleFormEmployeeListClickSendCommand(payload) {
      this.commandDataFormEmployeeSyncList = { ...payload }
      this.isShowFormEmployeeSyncList = true
    },

    classRowSelected(row) {
      if (this.hardware.hardware_uuid === row.hardware_uuid) {
        return 'row-selected cursor-pointer'
      } else {
        return 'cursor-pointer'
      }
    },

    handleFormCommandsClickCommand(command) {
      // if (['set_employee'].includes(command.sync_code)) {
      //   this.commandDataFormIdentifyMode = {
      //     title: command.title_th,
      //     syncCode: command.sync_code
      //   }
      //   this.isShowFormIdentifyMode = true
      //   return
      // }

      // if (['get_employee', 'delete_employee'].includes(command.sync_code)) {
      //   this.commandDataFormEmployeeList = {
      //     title: command.title_th,
      //     syncCode: command.sync_code
      //   }
      //   this.isShowFormEmployeeList = true
      //   return
      // }

      // if (
      //   ['get_device_info', 'get_employee_list'].includes(command.sync_code)
      // ) {
      //   this.commandDataFormCommand = {
      //     title: command.title_th,
      //     component: this.commandComponentType[command.sync_code],
      //     syncCode: command.sync_code
      //   }
      //   this.isShowFormCommand = true
      //   return
      // }

      if (
        ['get_device_info', 'get_employee_list'].includes(command.sync_code)
      ) {
        this.commandDataFormCommand = {
          title: command.title,
          component: this.commandComponentType[command.sync_code],
          syncCode: command.sync_code,
        }
        this.isShowFormCommand = true
        return
      }
    },

    handleFormCommandsClickClose() {
      this.isShowFormCommands = false
      this.hardware = {}
    },

    handleFormCommandClickBack() {
      this.isShowFormCommand = false
      this.timeout = setTimeout(() => {
        this.commandDataFormCommand = {}
      }, 200)
    },

    setDataRowSelected(row) {
      if (
        row.hardware_status &&
        row.hardware_status.title_th === 'อยู่ระหว่างซ่อม'
      ) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: 4000,
          message: 'เครื่องอยู่ระหว่างซ่อม',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
        return
      }

      this.hardware = { ...row }
      this.isShowFormCommands = true
      // this.loading = true
      // this.hardware = { ...row }

      // const hardwareModelCode = row.hardware_model.hardware_model_code

      // this.fetchCodes(hardwareModelCode)
      //   .then(res => {
      //     this.commands = _.uniqBy(
      //       res,
      //       'hardware_resource.hardware_resource_code'
      //     ).map(resource => ({
      //       ...resource.hardware_resource,
      //       resources: res.filter(
      //         status =>
      //           status.hardware_resource.hardware_resource_code ===
      //           resource.hardware_resource.hardware_resource_code
      //       )
      //     }))

      //     this.isShowFormCommands = true
      //     this.loading = false
      //   })
      //   .catch(error => {
      //     console.log(error.response)
      //     this.loading = false
      //   })
    },

    uniqByKeepLast(data, key) {
      return [...new Map(data.map((x) => [key(x), x])).values()]
    },

    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      Promise.all([
        this.fetchHardwares({ params: { company_uuid } }),
        this.fetchOrganizationsWithQueryString({
          company_uuid,
          queryString: {
            params: {
              field: 'organization_uuid,title_th',
            },
          },
        }),
        this.fetchEmployeesWithQueryString({
          company_uuid,
          queryString: {
            params: {
              field:
                'employee_uuid,employee_code,firstname_th,lastname_th,organization,position',
            },
          },
        }),
      ])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },

    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      if (this.isShowFormResponse) this.isShowFormResponse = false
      if (this.isShowFormEmployeeSyncList)
        this.isShowFormEmployeeSyncList = false
      if (this.isShowFormEmployeeList) this.isShowFormEmployeeList = false
      if (this.isShowFormIdentifyMode) this.isShowFormIdentifyMode = false
      if (this.isShowFormCommands) this.isShowFormCommands = false
      if (this.isShowFormCommand) this.isShowFormCommand = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },

  beforeRouteLeave(to, from, next) {
    if (
      this.isHardwareConnectionFormEmployeeListDataChange ||
      this.isHardwareConnectionFormIdentifyModeDataChange ||
      this.isShowFormCommand
    ) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'การทำงานยังไม่เสร็จสมบูรณ์ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังมีการทำงานอยู่',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
